import styled from "styled-components";

export const InfoContents = styled.div`
  /* padding-right: 50px; */
  /* width: 10%; */
  background: #ffffff;
  box-shadow: 6.04275px 26.1419px 34.875px rgba(0, 0, 0, 0.04725),
    2.38726px 10.3277px 13px rgba(0, 0, 0, 0.035),
    0.522213px 2.25918px 4.625px rgba(0, 0, 0, 0.02275);
  border-radius: 7px;

  width: 20%;
  height: 10%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 420px) {
    width: 85%;
    padding-inline: 10px;
    height: 11%;
  }

  @media screen and (max-width: 360px) {
    width: 88%;
    padding-inline: 10px;
    height: 11%;
  }

  @media screen and (min-width: 421px){
    width: 350px;
    padding-inline: 18px;
    height: 100px;
  }
`;

export const InfoPayment = styled.div`
  /* padding-right: 20px; */

  /* @media screen and (max-width: 420px) {
    width: 100%;
    padding-inline: 16px;
  } */
`;

export const FpContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
  justify-content: center;
  align-items: center;
  animation: fade-in 0.3s forwards;
`;

export const FpCenter = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

export const FpLoader = styled.div`
  padding-top: 30px;
  justify-content: center;

  span {
    display: inline-block;
    background-color: var(--color-azul-mrpay);
    width: 0px;
    height: 0px;
    border-radius: 50%;
    border: 1px solid white;
    margin: 0 8px;
    animation: bounce 0.6s infinite alternate;
    transform: translate3d(0);

    &:nth-child(2) {
      background-color: var(--color-dourado-mrpay);
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.4s;
    }

    @keyframes bounce {
      to {
        width: 16px;
        height: 16px;
        transform: translate3d(0, -16px, 0);
      }
    }
  }
`;
